export const Strings = {
  DEFAULT_TRUNCATE_LIMIT: 110,
};
